import React from 'react'
import Announcement from './announcement'
import Vespa from "../../assets/images/TodayPrizeScreen/vespa.svg"
import Gold from "../../assets/images/TodayPrizeScreen/gold.svg"
import Mandala from "../../assets/images/TodayPrizeScreen/mandala.svg"
import NassarMptors from "../../assets/images/TodayPrizeScreen/nassarmotors.svg"
import Sponsor from "../../assets/images/TodayPrizeScreen/sponsor.svg"
import '../../assets/css/style.scss'
import Header from '../Header'

export default function TodayPrizeCard({marginLeftCongra}) {
  return (
    <div className='col-12  px-4  mt-0 prize-card ' style={{paddingTop:`${marginLeftCongra}`}}>
      <Announcement title={"TODAYS's PRIZE"} />

      <div className='row  mt-1 px-2' >
        <div className='col-9'>
          <div className='row  prize-heading '>
            <span >Today's Tournament Price!</span>
          </div>
          <div className='row prize-sub-heading '>
           <span> All New Vespa VLX 125</span>
          </div>
          <div className='row todayprize-paragrapg pr-4 ' style={{color:"#828282"}}>
           <span> Get a chance to win 2022 - All New Vespa VLX 125-Sponsored by NASSAR MOTORS</span>
          </div>
          <div className='row todayprize-sub-paragrapg mt-0' style={{color:"#828282"}}>
          <span>  WITS in collaboration with NASSAR MOTORS brings you a chance to own VESPA VXL</span>
          </div> 
          <div className='row mt-1 todayprize-border '>
          </div>

{/* Lower Today Price  */}


          <div className='row d-flex  ' >
            {/* <div className='col-5 px-0  d-flex flex-row justify-content-between'>
              <div className='d-flex flew-row mt-2 mb-1'>
                <img width={"30px"} src={Gold} />
                <div className='d-flex mt-2 pl-2  flex-column'>
                  <span className='coupons-int' >23,00</span>
                  <span className='coupons-head' >Coupons Sold</span>

                </div>
              </div>
              <div className='d-flex flew-row mt-2 mb-1'>
                <img width={"30px"} src={Mandala} />
                <div className='d-flex pl-2 mt-2 flex-column '>
                  <span className='coupons-int' >115</span>
                  <span className='coupons-head' >Players</span>

                </div>
              </div>
            </div> */}



            {/* <div className='col-1 '> */}
              {/* <div className='todayprize-border-up'></div> */}
            {/* </div> */}
            <div className='col-5 '>
              <div className='row partner-head  '>OUR PARTNERS</div>
              <div className='row mb-2'>
                <img src={NassarMptors} />
                <img className='ml-2' src={Sponsor} />
              </div>

            </div>

          </div>






        </div>
        <div className='col-3 pl-1 pt-0 pb-0 pr-2 '  style={{width:"100%", height:"100%"}}>
          <img className='  today-price-left-img '  src={Vespa} />
        </div>
      </div>
    </div>
  )
}
